@if (enabled()) {
  @if (data.isLoading()) {
    <cue-loading style="height: 10px; width: 60px" />
  }
  @if (available()) {
    <div class="navigate-button" (click)="onOpenInNavigation()">
      <cue-icon [icon]="ICONS.cueDirections" />
      {{ translation.reservations.openInNavigation | transloco }}
    </div>
  }
}
